import { render, staticRenderFns } from "./VaimoMobileMenu.vue?vue&type=template&id=002e2f60&scoped=true&"
import script from "./VaimoMobileMenu.vue?vue&type=script&lang=ts&"
export * from "./VaimoMobileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoMobileMenu.vue?vue&type=style&index=0&id=002e2f60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002e2f60",
  null
  
)

export default component.exports